var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.headerBarFixed
    ? _c(
        "a-layout-header",
        {
          class: [
            _vm.fixedHeader && "ant-header-fixedHeader",
            _vm.sidebarOpened
              ? "ant-header-side-opened"
              : "ant-header-side-closed",
          ],
          style: { padding: "0" },
        },
        [
          _vm.mode === "sidemenu"
            ? _c(
                "div",
                { staticClass: "header", class: _vm.theme },
                [
                  _c("img", {
                    staticStyle: {
                      float: "left",
                      height: "40px",
                      margin: "10px 15px 0 20px",
                    },
                    attrs: {
                      src: _vm.tenantAreaInfo.imageUrl
                        ? _vm.$getStoreHttpUrl(_vm.tenantAreaInfo.imageUrl)
                        : require("@/assets/logoImg.png"),
                      alt: "logo",
                    },
                  }),
                  _c("span", { staticClass: "tagz" }, [
                    _vm._v(_vm._s(_vm.tenantAreaInfo.motto || "爱心小叮当")),
                  ]),
                  _c("user-menu", {
                    attrs: { isShowHeader: _vm.isShowHeader, theme: _vm.theme },
                  }),
                ],
                1
              )
            : _c("div", { class: ["top-nav-header-index", _vm.theme] }, [
                _c(
                  "div",
                  { staticClass: "header-index-wide" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "header-index-left",
                        style: _vm.topMenuStyle.headerIndexLeft,
                      },
                      [
                        _c("logo", {
                          staticClass: "top-nav-header",
                          style: _vm.topMenuStyle.topNavHeader,
                          attrs: { "show-title": _vm.device !== "mobile" },
                        }),
                        _vm.device !== "mobile"
                          ? _c(
                              "div",
                              { style: _vm.topMenuStyle.topSmenuStyle },
                              [
                                _c("s-menu", {
                                  attrs: {
                                    mode: "horizontal",
                                    menu: _vm.menus,
                                    theme: _vm.theme,
                                  },
                                }),
                              ],
                              1
                            )
                          : _c("a-icon", {
                              staticClass: "trigger",
                              attrs: {
                                type: _vm.collapsed
                                  ? "menu-fold"
                                  : "menu-unfold",
                              },
                              on: { click: _vm.toggle },
                            }),
                      ],
                      1
                    ),
                    _c("user-menu", {
                      staticClass: "header-index-right",
                      style: _vm.topMenuStyle.headerIndexRight,
                      attrs: { theme: _vm.theme },
                    }),
                  ],
                  1
                ),
              ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }